import Vue from "vue";
import App from "./App.vue";
import * as VueGoogleMaps from "gmap-vue";

export default function init() {
  const element = document.getElementById("contactList");

  Vue.use(VueGoogleMaps, {
    load: {
      key: "AIzaSyCqP9WhqxjG_YMk3XSFjiG3zOKRD9wGKAs"
    }
  });

  if (element) {
    Vue.config.productionTip = false;

    new Vue({
      render: createElement => {
        const context = {
          props: { ...element.dataset }
        };
        return createElement(App, context);
      }
    }).$mount("#contactList");
  }
}
